export const ALERT_THRESHOLD = 5

export const WELLNESS_DIMS = [
    { key: 'energy', labelKey: 'common.energy', icon: 'mdi-lightning-bolt', invert: false },
    { key: 'sleep_night', labelKey: 'common.sleep_night', icon: 'mdi-weather-night', invert: false },
    { key: 'tired', labelKey: 'dashboard.fatigue', icon: 'mdi-battery-low', invert: true },
    { key: 'stressed', labelKey: 'common.stressed', icon: 'mdi-brain', invert: true },
    { key: 'muscles_hurt', labelKey: 'dashboard.muscular', icon: 'mdi-arm-flex', invert: true },
]

export const goodValue = (raw, invert) => {
    const value = Number(raw || 0)
    if (!value) return 0
    return invert ? (11 - value) : value
}

const round1 = (value) => Math.round(value * 10) / 10

export const entriesOfDay = (roster, date) => {
    const entries = []
    roster.forEach(student => {
        const entry = (student.lastWellness || []).find(item => item && item.date === date)
        if (entry) entries.push({ student, entry })
    })
    return entries
}

export const buildRingValues = (entries) => {
    return WELLNESS_DIMS.map(dim => {
        const values = entries
            .map(item => goodValue(item.entry[dim.key], dim.invert))
            .filter(value => value > 0)
        const average = values.length ? values.reduce((a, b) => a + b, 0) / values.length : 0
        return { key: dim.key, icon: dim.icon, labelKey: dim.labelKey, value: round1(average) }
    })
}

export const buildAlarms = (entries) => {
    const rows = []
    entries.forEach(({ student, entry }) => {
        const low = []
        WELLNESS_DIMS.forEach(dim => {
            const value = goodValue(entry[dim.key], dim.invert)
            if (value > 0 && value < ALERT_THRESHOLD) low.push({ labelKey: dim.labelKey, value: round1(value) })
        })
        if (!low.length) return
        low.sort((a, b) => a.value - b.value)
        rows.push({ student, low, severity: low[0].value })
    })
    return rows.sort((a, b) => a.severity - b.severity)
}

export const ringsInAlert = (rings) => {
    return rings.filter(ring => ring.value > 0 && ring.value < ALERT_THRESHOLD).length
}
